type stateType = { queue: number }

export const state = () => ({
  queue: 0,
})

export const mutations = {
  increase(state: stateType, number: number = 1) {
    state.queue += number
  },
  decrease(state: stateType, number: number = 1) {
    state.queue -= number
    if (state.queue < 1) state.queue = 0
  },
}

export const getters = {
  isLoadingActive(state: stateType) {
    return state.queue > 0
  },
}
